<template>
  <div class="expandable-container">
    <div
        ref="content"
        class="content-wrapper position-relative"
        :style="contentStyle"
    >
      <slot></slot>
    </div>

    <div
        v-if="isOverflown && !isExpanded"
        class="fade-overlay"
    ></div>

    <div v-if="isOverflown" class="button-wrapper">
      <a
          href="#"
          @click.prevent="toggleExpand"
          class="btn-link link-danger btn-sm"
      >
        <i :class="(isExpanded ? btnIco.compress :btnIco.expand) + ' me-1'"/>
        {{ isExpanded ? btnTitle.compress : btnTitle.expand }}
      </a>
      <!--
      <button @click.prevent="toggleExpand" class="--expand-btn btn btn-primary btn-sm">
        <i :class="(isExpanded ? btnIco.compress :btnIco.expand) + ' me-1'"/>

      </button>
      -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExpandableText',
  props: {
    // Limit výšky v pixelech, po kterém se text zkrátí
    maxHeight: {
      type: Number,
      default: 120
    },
    btnTitle:{
      type: Object,
      default: {
        expand: "Zobrazit více x",
        compress: "Zobrazit mene y",
      }
    },
    btnIco:{
      type: Object,
      default: {
        expand: "bi bi-arrow-bar-down",
        compress: "bi bi-arrow-bar-up",
      }
    }
  },
  data() {
    return {
      isExpanded: false,
      isOverflown: false
    };
  },
  computed: {
    contentStyle() {
      if (this.isExpanded) {
        return {
          maxHeight: 'none'
        };
      }
      return {
        maxHeight: `${this.maxHeight}px`,
        overflow: 'hidden'
      };
    }
  },
  mounted() {
    // Ověříme výšku po vykreslení komponenty
    this.checkOverflow();
    // Pro jistotu reagujeme na změnu velikosti okna
    window.addEventListener('resize', this.checkOverflow);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkOverflow);
  },
  methods: {
    checkOverflow() {
      this.$nextTick(() => {
        const element = this.$refs.content;
        if (element) {
          // Pokud je skutečná výška obsahu větší než nastavený limit, aktivujeme zkrácení
          this.isOverflown = element.scrollHeight > this.maxHeight;
        }
      });
    },
    toggleExpand() {
      this.isExpanded = !this.isExpanded;
      this.$emit('toggle', this.isExpanded);
    }
  }
};
</script>

<style scoped>
.expandable-container {
  position: relative;
  width: 100%; /* Šířka se přizpůsobí nadřazenému prvku s pevnou šířkou */
}

.content-wrapper {
  transition: max-height 0.3s ease-out; /* Plynulý přechod při rozbalení */
}

/* Přechod do ztracena (gradient) */
.fade-overlay {
  position: absolute;
  bottom: 35px; /* Umístění těsně nad tlačítkem */
  left: 0;
  right: 0;
  height: 50px;
  /* Přechod z průhledné do barvy pozadí (zde bílá, uprav podle potřeby) */
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1));
  pointer-events: none; /* Aby nebránil případnému označování textu pod ním */
}

.button-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 5px;
  background-color: #fff; /* Stejné pozadí jako podklad, aby překrylo případný text */
  //border: 1px dashed limegreen;
}

</style>